import ParentAccountEthnicityReportContainer from './parent_account_ethnicity_report_container';

const ParentAccountEthnicityReport = ParentAccountEthnicityReportContainer;
export default ParentAccountEthnicityReport;
